import React, {Component} from 'react'
import {style, media, merge} from 'glamor'

export default class Layout extends Component {
  render(){
    return (
      <div
        {...this.props}
        {...style({
          width: '100%',
          height: '100%',
          display: 'flex'
        })}
      >
        {this.props.children}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Layout.js
 **/